import { MdKeyboardArrowDown } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section``;

export const InputArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 125px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100px;
  }
`;

export const Arrow = styled(MdKeyboardArrowDown)`
  height: 20px;
  width: 20px;
  color: ${ColorPalette.HEX.OuterSpace} !important;
`;

export const Code = styled.span`
  color: ${ColorPalette.HEX.Manatee};
  font-size: 18px;

  @media ${({ theme }) => theme.device.mobile} {
    font-size: inherit;
  }
`;

export const Flag = styled.img`
  object-fit: cover;
  border-radius: 50%;
  width: 32px;
  height: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 24px;
    height: 24px;
  }
`;
